<template>
<div style="height:100%;width:100%; display: flex;flex-direction: column;">

    <div style="height:50px;width:100%;background-color:#f8f8f8;">
    
    <div  style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
      
    <div style="width:40%;display:flex" > 
      <div style="width:4px;background-color:#970B0B;height:40px"></div> 
      <div style="margin:5px;color:#970B0B;">授权列表</div> 
    </div>
    <div style="width:50%;justify-content: center;display: flex;">
    </div>
    <div style="width:15%;color:#970B0B">
        <el-button  @click="RightAddClick"  size="mini" style="width:70%;background-color:#970B0B;color:#fff">新增授权</el-button> 

    </div>

    </div>

    </div>

<div style="width:100%;height:100%">
  

                  


    <el-table 
    :data="groupIist"
     height="500px"
    size= "medium"
    style="width: 100%;">
    <el-table-column
      fixed
      prop="authid"
      label="authid"
      width="100">
    </el-table-column>
    <el-table-column
      prop="cid"
      label="CID"
      width="200">
    </el-table-column>
    <el-table-column
      prop="phonenumber"
      label="账号"
      width="150">
    </el-table-column>
    <el-table-column
      prop="aid"
      label="用户ID"
      width="150">
    </el-table-column>
        <el-table-column
      prop="username"
      label="用户"
      width="150">
    </el-table-column>
            <el-table-column
      prop="createTime"
      label="创建时间"
      width="200">
    </el-table-column>
            <el-table-column
      prop="updateTime"
      label="更新时间"
      width="200">
    </el-table-column>


    <el-table-column
      fixed="right"
      label="操作"
      width="150">
     <template slot-scope="scope">
        <el-button
          size="mini"
          disabled
          @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        <el-button
          size="mini"
          @click="handleDelete(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column>

  </el-table>
  


</div>


 <el-pagination
      style="text-align:center;margin:10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
</el-pagination>



<el-dialog
  :visible.sync="centerDialogVisible"
  width="80%"
  center
  :destroy-on-close = true
  :show-close = false
  :close-on-click-modal = false
  :close-on-press-escape = false
  >
<div>
      <div style="height:40px;width:100%;background-color:#fff;">
        <div  style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">
          
            <div style="width:40%;display:flex" > 
              <div style="width:4px;background-color:#970B0B;height:40px"></div> 
              <div style="margin:5px;color:#970B0B;">授权信息</div> 
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
        </div>
    </div>

        <div style="height:60px;width:100%;background-color:#f8f8f8;">
        <div  style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">
          
      
    <div style="width:70%;display:flex" > 
             
              
  <!--     <div v-if="isGroupEdit" style="display: flex;margin:10px;">
          <div style="flex: 1;width:60px;margin-left:5px;margin-right:15px">AID：{{groupInfo.aid}}
        </div>
      </div> -->

<!--      <div style="display: flex;margin-left:10px;margin-top:10px;">
      <div style="flex: 1;width:80px;margin:5px;margin-right:10px">用户AID：</div>
      <el-input
      style="width:180px;"
       placeholder="请输入用户的AID"
       v-model="groupInfo.aid"
       type="text"
       clearable>
      </el-input>
      </div>

     <div style="display: flex;margin-left:10px;margin-top:10px;">
      <div style="flex: 1;width:50px;margin:5px;margin-right:10px">姓名：</div>
      <el-input
      style="width:180px;"
       placeholder="请输入用户的姓名"
       v-model="groupInfo.username"
       type="text"
       clearable>
      </el-input>
      </div> -->

     <div style="display: flex;margin-left:10px;margin-top:10px;">
      <div style="flex: 1;width:80px;margin:5px;margin-right:10px">手机号：</div>
      <el-input
      style="width:250px;"
       placeholder="请输入用户的手机号"
       v-model="groupInfo.phonenumber"
       type="text"
       clearable>
      </el-input>
      </div>

   <div style="display: flex;margin-left:10px;margin-top:10px;">
      <div style="flex: 1;width:60px;margin:5px;margin-right:10px">CID：</div>
      <el-input
      style="width:250px;"
       placeholder="请输入17位CID"
       v-model="groupInfo.cid"
       type="text"
       clearable>
      </el-input>
      </div>

   </div>

      <div style="width:50%;justify-content: center;display: flex;"></div>
         <div style="width:15%;color:#970B0B"></div>
      </div>
    </div>
    <div style="color:#970B0B;font-size:12px;margin:20px 0px 0px 20px">提醒：用户必须提前注册才能给他授权！</div>

</div>

  <span slot="footer" class="dialog-footer ">
    <el-button style="width:120px"  @click="centerDialogVisible = false">取 消</el-button>
    <el-button style="background-color:#970B0B;color:#fff;width:120px"  @click="getUserInfoByPhoneNumber">确 定</el-button>
  </span>
</el-dialog>


</div>

</template>

<script>

import TMApipath from 'TMApipath'
import {formatTime} from 'TMUtils'


  export default {
    methods: {
      handleSizeChange(val) {
        var _this =this;
        _this.pageInfo.size =  val;
        _this.getAuthListByPage(_this.pageInfo.val,_this.pageInfo.size);
      },
      handleCurrentChange(val){
        console.log(`当前页: ${val}`);
        // console.log(`当前页: ${val}`);
        var _this = this
        _this.pageInfo.val = val
        _this.getAuthListByPage(_this.pageInfo.val,_this.pageInfo.size);

      },
      preclick(val){
        console.log(`当前页: ${val}`);

      },
       
      
      handleDelete(index, rows) {//待实现
        var _this =this;
        console.log(`当前页: ${index}`);

        _this.$confirm('此操作将永久删除该授权, 是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {

         _this.deleteAuthDevice(rows.authid)



        }).catch(() => {
                 
        });

      },

      handleEdit(index, rows) {//待实现
        console.log(`当前页: ${index}`);
        console.log(`当前页: ${rows}`);

        // this.centerDialogVisible =  true;
        // this.isGroupEdit =  true;

        // this.groupInfo = {
        //   cid: rows.cid,
        //   username: rows.username,
        //   phonenumber: rows.phonenumber,

        // }
          

      },
      
      RightAddClick(){
        this.centerDialogVisible =  true;
        this.isGroupEdit =  false;

        this.groupInfo = {
          aid:'',
          cid: '',
          username: '',
          phonenumber: ''
        };


      },
      addAuthDevice(aid,username,phonenumber,cid){

          var _this = this;

          if (!aid ||!username || !phonenumber || !cid) {
              _this.$message.error("请输入相关信息");
            return
          }
 
          var params = {
            username: username,
            phonenumber: phonenumber,
            cid: cid,
            aid: aid
          }
          console.log('addAuthDevice',params)
          
      
          var reqdata = {}
          var { urls} = _this.getresult(TMApipath.DEVICECUSTOMER,TMApipath.URL_API_ADDAUTHDEVICE, reqdata);

          console.log(urls)

           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(urls, params).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
                _this.centerDialogVisible = false;
              // vuex记录
          _this.getAuthListByPage(_this.pageInfo.val,_this.pageInfo.size);
            }else{
              _this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
              _this.$message.error("系统异常");
            console.log(response)
          });



      },
       getUserInfoByPhoneNumber(){//根据CID拉取AID

          var _this = this

          if (!_this.groupInfo.phonenumber || !_this.groupInfo.cid) {
              this.$message.error("请输入手机号和CID");
            return
          }


          var reqdata = {phonenumber : _this.groupInfo.phonenumber}  
          var { urls} = _this.getresult(TMApipath.USER,TMApipath.URL_API_getUserInfoByPhoneNumber, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.post(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {

               var aid = response.data.aid
               var username = response.data.username
               var phonenumber = _this.groupInfo.phonenumber;
               var cid = _this.groupInfo.cid;

                _this.addAuthDevice(aid,username,phonenumber,cid);

            }else{
              this.$message.error('此手机号未注册');
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
     getAuthListByPage(pageIndex, pageSize){

          var _this = this

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.DEVICECUSTOMER, TMApipath.URL_API_GETAUTHLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录
                _this.pageInfo.total = response.data.total

                _this.groupIist =[];

              for(var items in response.data.list){
                var item = response.data.list[items]

                var cutFeed ={
                  authid: item.authid,
                  cid: item.cid,
                  phonenumber: item.phonenumber,
                  aid: item.aid,
                  username: item.username,
                  dataTimestamp: item.dataTimestamp ? formatTime(item.dataTimestamp): '--',
                  createTime: formatTime(item.createDate),
                  updateTime: item.updateDate ? formatTime(item.updateDate): '--'

                }

                _this.groupIist.push(cutFeed);
              }


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },

      deleteAuthDevice(authid){

          var _this = this



          var params = {
            authid: authid
          }
         var reqdata = {}
          var { urls} = _this.getresult(TMApipath.DEVICECUSTOMER,TMApipath.URL_API_DELETEAUTHDEVICE, reqdata);

           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});

          _this.axios.post(urls, params).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
                _this.centerDialogVisible = false;

              // vuex记录
      _this.getAuthListByPage(_this.pageInfo.val,_this.pageInfo.size);

            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },

    },
    mounted() {
      var _this = this
      _this.getAuthListByPage(_this.pageInfo.val,_this.pageInfo.size);
      

    },
    data() {
      return {
        pageInfo:{
          val:1,
          size: 10,
          total:0
        },
        centerDialogVisible: false,
        isGroupEdit:false,
        groupInfo:{
          aid: '',
          username: '',
          phonenumber: ''
        },
        groupIist: []
      }
    }
  }
</script>

<style lang="stylus" scoped>
.groups
    overflow: hidden

.rightButton
  width: 30px
.container_right
    margin: 5px
    display: flex
    justify-content: center
    align-items: flex-start
.el-dialog_header
    padding:0px
</style>